import { IntlShape } from "react-intl";

import { ReactComponent as ArrowDown } from "assets/images/icons/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "assets/images/icons/ArrowUp.svg";
import { formatWeight } from "helpers/commonHelpers";

interface getCommoditiesColumnsProps {
  intl: IntlShape;
}

export default function getCommoditiesColumns({ intl }: getCommoditiesColumnsProps) {
  const columns = [
    {
      Header: intl.formatMessage({ id: "quotation-form.viewCommodities.name", defaultMessage: "Name" }),
      Cell: (props: any) => <p className="font-b9 commodities-name">Commodity {props.row.index + 1}</p>,
    },
    {
      Header: intl.formatMessage({ id: "quotation-form.viewCommodities.handlingUnit", defaultMessage: "Handling Unit" }),
      accessor: ({ units, handling_unit }: any) => ({ units, handling_unit }),
      Cell: ({ value }: any) => `${value.units} ${value.handling_unit}`,
    },
    {
      Header: intl.formatMessage({ id: "quotation-form.viewCommodities.weight", defaultMessage: "Weight" }),
      accessor: ({ weight, w_unit }: any) => ({ weight, w_unit }),
      Cell: ({ value }: any) => formatWeight(value.weight, value.w_unit),
    },
    {
      Header: intl.formatMessage({ id: "quotation-form.viewCommodities.totalWeight", defaultMessage: "Total Weight" }),
      accessor: ({ weight, units, w_unit }: any) => ({ weight, units, w_unit }),
      Cell: ({ value }: any) => formatWeight(value.weight * value.units, value.w_unit),
    },
    {
      Header: intl.formatMessage({ id: "quotation-form.viewCommodities.dimensions", defaultMessage: "Dimensions" }),
      accessor: ({ length, width, height, m_unit }: any) => ({ length, width, height, m_unit }),
      Cell: ({ value }: any) =>
        `${value.length?.toFixed(1) || 0} x ${value.width?.toFixed(1) || 0} x ${value.height?.toFixed(1) || 0} ${
          value.m_unit
        }`,
    },
    {
      Header: () => null,
      id: "expander",
      Cell: ({ row }: any) => (
        <div className="d-ex align-items-center position-relative">{row.isExpanded ? <ArrowUp /> : <ArrowDown />}</div>
      ),
    },
  ];

  return columns;
}
